export const getSessionProvider = props =>
	props && props.currentSession && props.currentSession.provider;
export const getSessionUser = props => props && props.currentSession && props.currentSession.user;

export const CHECKS = [
	(sessionUser, sessionProvider) => sessionUser.firstname && sessionUser.lastname,
	(sessionUser, sessionProvider) => sessionUser.location,
	(sessionUser, sessionProvider) => sessionProvider.profession,
	(sessionUser, sessionProvider) => sessionProvider.category,
	(sessionUser, sessionProvider) => sessionProvider.profile.avatarImage,
	(sessionUser, sessionProvider) => sessionProvider.profile.backgroundImage,
	(sessionUser, sessionProvider) => sessionProvider.profile.brief,
	(sessionUser, sessionProvider) => sessionProvider.profile.about,
	(sessionUser, sessionProvider) =>
		sessionProvider.profile.images && sessionProvider.profile.images.length > 0,
	(sessionUser, sessionProvider) => sessionUser.contacts && sessionUser.contacts.length > 0
	// Excluded; opened invites
	// Excluded; communities length
];

const getGettingStartedProgress = (sessionUser, sessionProvider) =>
	sessionUser && sessionProvider
		? Math.round(
				(CHECKS.map(check => check(sessionUser, sessionProvider)).filter(val => !!val).length /
					CHECKS.length) *
					100
		  )
		: 0;

export default getGettingStartedProgress;



// WEBPACK FOOTER //
// ./src/profile/gettingStartedProgress.js